<div class="TRS__sub-section">
  <header class="TRS__sub-section__header">
    <h3 class="tertiary-heading">Paid Time Off</h3>
    <p class="TRS__sub-section__header__description">
      At SOLV Energy, we care about you and recognize the value of balancing work with personal
      life. We are committed to supporting you through life's moments, ensuring you have the time
      you need to recharge. Discover how we value your time and invest in your overall wellbeing
      below.
    </p>
  </header>

  <!-- PTO Cards -->
  <div class="PTO">
    @for (ptoCard of ptoCards; track ptoCard) {
      <div class="PTO__card">
        <h4 class="PTO__card__title" [innerText]="ptoCard.title"></h4>
        @if (ptoCard.days !== 'Unlimited') {
          <span [innerText]="(ptoCard.days | number:'1.0-1') + ' ' + (ptoCard.days === '1' ? 'day' : 'days' )"
          class="PTO__card__body"></span>
        }
        @if (ptoCard.days === 'Unlimited') {
          <span [innerText]="ptoCard.days" class="PTO__card__body"></span>
        }
      </div>
    }
  </div>
</div>
